












import { Component, Emit, Vue } from 'vue-property-decorator';

@Component
export default class FileDropZone extends Vue {
  isFileOver = false;
  files: any[] = [];

  mounted() {
    // @ts-ignore
    // noinspection TypeScriptUnresolvedFunction
    this.$refs.dropzone.addEventListener('drop', this.dropHandler);
    // @ts-ignore
    // noinspection TypeScriptUnresolvedFunction
    this.$refs.dropzone.addEventListener('dragover', this.dragOverHandler);
    // @ts-ignore
    // noinspection TypeScriptUnresolvedFunction
    this.$refs.dropzone.addEventListener('dragleave', this.dragLeaveHandler);
  }

  private dropHandler(e: DragEvent) {
    e.preventDefault();
    this.files = [];

    if (e.dataTransfer && e.dataTransfer.items) {
      // Use DataTransferItemList interface to access the file(s)
      for (let i = 0; i < e.dataTransfer.items.length; i++) {
        // If dropped items aren't files, reject them
        if (e.dataTransfer.items[i].kind === 'file') {
          this.files.push(e.dataTransfer.items[i].getAsFile());
        }
      }
    } else if (e.dataTransfer && e.dataTransfer.files) {
      // Use DataTransfer interface to access the file(s)
      for (let i = 0; i < e.dataTransfer.files.length; i++) {
        this.files.push(e.dataTransfer.files[i].name);
      }
    }

    this.emitFileDropped();
    this.isFileOver = false;
  }

  @Emit('files-dropped')
  private emitFileDropped() {
    return this.files;
  }


  private dragOverHandler(e: DragEvent) {
    e.preventDefault();
    this.isFileOver = true;
  }

  private dragLeaveHandler() {
    this.isFileOver = false;
  }
}
